import { itemMatchesQuery, normalizeLimit } from "./search-helpers.js";

// Filters by title (and any item `keywords`). Passes through when noFilter or
// query is empty; header rows always pass. When `maxResults` is set, stops after
// that many matched (non-header) items so a broad query over a large list never
// renders thousands of rows synchronously. Pinned rows bypass matching, always
// render last, and reserve their slots within the cap — so a pinned action row
// survives even a broad query that fills the cap.
export function filterBySearch(items, search, noFilter, getItemTitle, maxResults) {
  const hasQuery = (search?.length ?? 0) > 0;
  if (noFilter || !hasQuery) {
    return items;
  }

  const pinned = items.filter((item) => item?.pinned);
  const query = search.toLowerCase();
  const limit = normalizeLimit(maxResults);
  const cap = limit === null ? null : Math.max(0, limit - pinned.length);
  const matches = [];
  let matched = 0;

  for (const item of items) {
    if (item?.header) {
      matches.push(item);
      continue;
    }
    if (item?.pinned) {
      continue;
    }
    if (itemMatchesQuery(item, query, getItemTitle)) {
      if (cap !== null && matched >= cap) {
        break;
      }
      matches.push(item);
      matched++;
    }
  }

  return [...matches, ...pinned];
}
